@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.DragAndDropFile {
  @extend %font-family-primary;

  align-items: center;
  background-color: $theme-color-table-header-background;
  border: 2px dashed $theme-color-table-border ;
  border-radius: 6px;
  padding: 80px;
  text-align: center;
  display: flex;
  flex-direction: column;
  row-gap: 16px;

  &.dragOver {
    background-color: $theme-drag-and-drop-box-on-drag-color;
    border: 2px dashed $theme-color-primary;
  }

  &.dropped {
    padding: 120px 0;
    height: 188px;
    justify-content: center;
    align-items: center;
  }
}
